import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "./popupPage.css"; // Reuse existing styles

const UserInfoPopUp = ({
  onClose,
  infoData 
}) => {
  useEffect(() => {
    console.log("UserInfoPopUp mounted");
    console.log("infoData:", infoData);
  }, [infoData]);

  if (!infoData) {
    console.log("Popup not rendered because infoData is null");
    return null;
  }

  const fields = [    
    { key: "email", label: "Email" },
    { key: "role", label: "Role" },
    { key: "tenantName", label: "Tenant Name" },
    { key: "deviceId", label: "Associated Device ID" },

  ];

  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="popup-header">
          <span className="popup-title">User Information</span>
          <button className="close-btn" onClick={onClose}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className="user-info-content">
          {fields
            .filter((field) => field.key !== "deviceId" || infoData.role === "viewer")
            .map((field) => (
            <div key={field.key} className="info-row">
              <strong>{field.label}:</strong>
              <span>{infoData[field.key] || "N/A"}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserInfoPopUp;
